import * as React from 'react';
import { Modal, Button } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import Utility from 'Core/Utility';

export interface Props extends ModalProps {
  children: React.ReactNode;
  condition?: boolean;
  showCancel?: boolean;
  actions?: React.ReactNode[];
  message?: React.ReactNode;
}

export interface State {
  showModal?: boolean;
}

export default class IfNotTrueModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  onClick = (event: React.SyntheticEvent) => {
    if (!this.props.condition) {
      event.stopPropagation();
      this.setState({ showModal: true });
    } else {
      const child = this.props.children as React.ReactElement<any>;
      child.props.onClick?.call(this, event);
    }
  };

  onCancel = () => {
    this.setState({ showModal: false });
  };

  closeModalThenDoAction = callBack => {
    this.setState({ showModal: false });
    callBack?.call(this);
  };

  renderFooter = () => {
    // Change Button click to one where we close the modal then click the button
    var clonedActions = this.props.actions?.map(x => {
      let oldbutton = x as React.ReactElement<any>;
      let oldButtonOnClick = oldbutton.props.onClick;
      let newButton = React.cloneElement(oldbutton, {
        onClick: () => this.closeModalThenDoAction(oldButtonOnClick),
      });
      return newButton;
    });

    return (
      <>
        {clonedActions?.map(button => {
          return button;
        })}
        {this.props.showCancel && (
          <Button type="default" onClick={this.props.onCancel ?? this.onCancel}>
            {this.props.cancelText ?? 'Cancel'}
          </Button>
        )}
      </>
    );
  };

  voidValue: void;

  render() {
    let { children, condition, actions, message, ...modalProps } = this.props;
    let modifiedChildren = Utility.replaceChildProps(children, { onClick: this.onClick });
    return (
      <>
        <Modal
          closable={true}
          onCancel={x => this.setState({ showModal: false })}
          visible={this.state.showModal}
          {...modalProps}
          footer={this.renderFooter()}>
          {message}
        </Modal>
        {modifiedChildren}
      </>
    );
  }
}
